import React from 'react';
import { Select } from 'antd';
import useContainerRef from '@src/hooks/utils/useContainerRef';
import { StyledResizeLabel, StyledResizeWrapper } from './styled';

const options = [
  { label: 'Small', value: 's' },
  { label: 'Medium', value: 'm' },
  { label: 'Large', value: 'l' },
];

export const CHART_SIZE_MAPPING = {
  s: { length: '380px', height: '200px' },
  m: { length: '40%', height: '200px' },
  l: { length: '100%', height: '300px' },
  diag: { length: '100%', height: '450px' },
};


export const getChartStyle = (size, diagMode) => {
  return diagMode ? {
    gridTemplateColumns: '1fr',
  } : {
    gridTemplateColumns: `repeat(auto-fill,minmax(${CHART_SIZE_MAPPING[size].length}, 1fr))`,
  }
}

function Resize({ value, onChange }) {

  const { containerRef, getContainer } = useContainerRef();

  return (
    <StyledResizeWrapper ref={containerRef}>
      <StyledResizeLabel>Size</StyledResizeLabel>
      <Select
        value={value}
        bordered={false}
        onChange={onChange}
        options={options}
        dropdownStyle={{ minWidth: 100 }}
        getPopupContainer={getContainer}
      />
    </StyledResizeWrapper>
  )
}

export default Resize;
